import {useGetHomepageTakeoverInMemoryCacheClient} from './useGetHomepageTakeoverInMemoryCache.client';
import {useGetHomepageTakeoverInMemoryCacheServer} from './useGetHomepageTakeoverInMemoryCache.server';

export const useGetHomepageTakeoverInMemoryCache = process.browser
  ? useGetHomepageTakeoverInMemoryCacheClient
  : useGetHomepageTakeoverInMemoryCacheServer;
